var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBotnPnico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#6b0c0c;}.cls-3{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-bot\xF3n-p\xE1nico") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_20",
    "data-name": 20
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M183.13,104.71a18.7,18.7,0,0,1-.79,1.77,5.35,5.35,0,0,1-4,2.83c-5.5.84-11,1.69-16.5,2.49a5.58,5.58,0,0,1-6.46-4.32,5.52,5.52,0,0,1,4.66-6.72c5.52-.93,11.05-1.77,16.59-2.58a5.61,5.61,0,0,1,6.1,3.6c.13.32.29.64.44,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.12,99.67A15.82,15.82,0,0,1,47.71,97a5.55,5.55,0,0,1,5.58-1.62c5.14,1,10.28,2,15.41,3,3.78.75,5.84,3.69,5,7.09a5.42,5.42,0,0,1-6.19,4.13c-4.44-.79-8.85-1.73-13.28-2.6-1.07-.21-2.15-.37-3.21-.6a5.78,5.78,0,0,1-4.59-4.05,2.35,2.35,0,0,0-.32-.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "114.83 84.43 114.83 84.43 114.83 84.43 114.83 84.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.7,119.5a34.85,34.85,0,0,0-23.45-33.19,34.49,34.49,0,0,0-11.42-1.88v6a28.53,28.53,0,0,1,21.84,10,28.69,28.69,0,0,1,5.66,10.06,29.18,29.18,0,0,1,1.33,9c0,9.8,0,19.76,0,29.38V156H85.6v-6c0-10.46,0-21.29.05-31.93a26.49,26.49,0,0,1,2.78-11.23,27.46,27.46,0,0,1,7.45-9.62,27.85,27.85,0,0,1,14.52-6.4,35.61,35.61,0,0,1,4.43-.28v-6h0a41,41,0,0,0-5.17.33A34.53,34.53,0,0,0,83,104.21,32.41,32.41,0,0,0,79.61,118c0,14.41,0,28.81,0,43.21,0,.25,0,.5,0,.8h70c0-.35.05-.64.05-.92C149.69,147.21,149.67,133.35,149.7,119.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71,178.9c.63-2,1.22-3.8,1.82-5.62.71-2.18,1.5-4.33,2.12-6.53a1.37,1.37,0,0,1,1.6-1.16q25.88,0,51.75,0c8.2,0,16.41,0,24.61,0a1.26,1.26,0,0,1,1.46,1c1.2,3.88,2.51,7.74,3.78,11.61,0,.17.08.35.15.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.58,76.52a5.58,5.58,0,0,1-9.68,3.93c-2.11-2.45-4.1-5-6.11-7.55-1.72-2.16-3.53-4.26-5.05-6.56a5.39,5.39,0,0,1,1.64-7.49,5.64,5.64,0,0,1,7.34,1c2.08,2.43,4,5,6,7.46,1.46,1.82,2.93,3.62,4.36,5.46A5.34,5.34,0,0,1,90.58,76.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157,59.83a5.36,5.36,0,0,1,4.46,3,5.14,5.14,0,0,1-.37,5.86c-2.24,2.77-4.64,5.41-7,8.09-1.45,1.67-2.92,3.34-4.41,5a5.52,5.52,0,0,1-8,.52,5.63,5.63,0,0,1-.27-8.18c3.51-3.93,7-7.92,10.44-11.88A6.29,6.29,0,0,1,157,59.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.05,57.92c0,2.84,0,5.68,0,8.52a5.25,5.25,0,0,1-2.65,4.71,5.38,5.38,0,0,1-5.41.23,5.2,5.2,0,0,1-3.14-4.76c-.09-5.83,0-11.66,0-17.49a5.68,5.68,0,0,1,3.9-4.9,5.85,5.85,0,0,1,6,1.68A5.72,5.72,0,0,1,121,49.72c0,2.73,0,5.47,0,8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.57,95.65a3.18,3.18,0,0,0-2.75,1.18,2.86,2.86,0,0,0-.42,3.07,3.19,3.19,0,0,0,3.19,1.85,21.55,21.55,0,0,1,14.79,5.75,20.37,20.37,0,0,1,6.46,10.9c.41,1.91.49,3.89.85,5.81a2.89,2.89,0,0,0,2.84,2.45,3.32,3.32,0,0,0,.92-.14c1.57-.5,2.25-1.78,2.15-4.07a28.13,28.13,0,0,0-27.87-26.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBotnPnico);
export default __webpack_public_path__ + "static/media/ic-botón-pánico.844d3213608900bda74cad233a54effb.svg";
export { ForwardRef as ReactComponent };